var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomAiflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .hatch_een{fill:#265AA5;} .hatch_twee{fill:#FFC5BB;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "hatch_twee",
    d: "M8.707,6H7.293l3-3h1.414L8.707,6z M7.707,3H6.293L6,3.293v1.414L7.707,3z M15.707,3h-1.414l-3,3h1.414 L15.707,3z M25,5.707V4.293L23.293,6h1.414L25,5.707z M19.707,3h-1.414l-3,3h1.414L19.707,3z M23.707,3h-1.414l-3,3h1.414L23.707,3 z M18,28.707L22.707,24h-1.414L18,27.293V28.707z M24.293,29h1.414L29,25.707v-1.414L24.293,29z M29,28.293L28.293,29H29V28.293z M18.707,24H18v0.707L18.707,24z M21.707,29l5-5h-1.414l-5,5H21.707z M2.707,24H2v0.707L2.707,24z M13,28.293L12.293,29H13V28.293z M2,28.707L6.707,24H5.293L2,27.293V28.707z M8.293,29h1.414L13,25.707v-1.414L8.293,29z M5.707,29l5-5H9.293l-5,5H5.707z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hatch_een",
    d: "M29,23h-4v-8.5c0-0.276-0.224-0.5-0.5-0.5h-1.995L16,9.136V7h9c0.552,0,1-0.448,1-1V3 c0-0.552-0.448-1-1-1H6C5.448,2,5,2.448,5,3v3c0,0.552,0.448,1,1,1h9v2.129L8.505,14H6.5C6.224,14,6,14.224,6,14.5V23H2 c-0.552,0-1,0.448-1,1v5c0,0.552,0.448,1,1,1h11c0.552,0,1-0.448,1-1v-5c0-0.552-0.448-1-1-1H7v-8h1.495l6.405,4.8 c0.178,0.133,0.389,0.2,0.6,0.2s0.422-0.067,0.6-0.2l6.41-4.8H24v8h-6c-0.552,0-1,0.448-1,1v5c0,0.552,0.448,1,1,1h11 c0.552,0,1-0.448,1-1v-5C30,23.448,29.552,23,29,23z M6,3h19v3H6V3z M13,29H2v-5h11V29z M15.5,19l-6-4.5l6-4.5l6,4.5L15.5,19z M29,29H18v-5h11V29z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomAiflow);
export default __webpack_public_path__ + "static/media/custom-aiflow.73f2c9831627813751a57c1bfaeeb8b8.svg";
export { ForwardRef as ReactComponent };